(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-content"] && !Shopify.designMode) return;
  try {
    
  var swiperCards = new Swiper(".swiper.is-about", {
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    spaceBetween: 4,
    speed: 750,
    navigation: {
      nextEl: '.swiper-btn-next',
      prevEl: '.swiper-btn-prev',
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        spaceBetween: 20,
        loop: false,
        centeredSlides: false,
      },
      1201: {
        slidesPerView: 4,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        spaceBetween: 20,
        loop: false,
        centeredSlides: false,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["business-cards"] && !Shopify.designMode) return;
  try {
    
  var swiperBC = new Swiper(".swiper.is-bc", {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: 'true',
    speed: 750,
    navigation: {
      nextEl: '.swiper-btn-next',
      prevEl: '.swiper-btn-prev',
    },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-swiper"] && !Shopify.designMode) return;
  try {
    
  var swiperCards = new Swiper(".swiper.is-cards", {
    slidesPerView: 1,
    spaceBetween: 8,
    loop: 'true',
    speed: 750,
    navigation: {
      nextEl: '.swiper-btn-next',
      prevEl: '.swiper-btn-prev',
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: 'true',
    },
    breakpoints: {
      479: {
        slidesPerView: 2,
      },
      991: {
        slidesPerView: 3,
      },
      1201: {
        slidesPerView: 4,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-about"] && !Shopify.designMode) return;
  try {
    
var swiperGrid = new Swiper(".swiper.is-cards-swipe", {
  effect: "cards",
  cardsEffect: {
    perSlideRotate: 1,
    perSlideOffset: 50,
  },
  autoplay: {
    delay: 2500
  },
  centeredSlides: true,
  allowTouchMove: false,
  slidesPerView: "auto",
  loop: true,
  navigation: {
    nextEl: '.swiper-btn-next',
    prevEl: '.swiper-btn-prev',
  }
});

ScrollTrigger.create({
  trigger: ".swiper.is-cards-swipe",
  start: "top 85%",
  end: "bottom top",
  toggleClass: {targets: ".swiper.is-cards-swipe", className: "active"}
});
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
// MARQUEE POWER-UP
window.addEventListener("DOMContentLoaded", (event) => {
  // attribute value checker
  function attr(defaultVal, attrVal) {
    const defaultValType = typeof defaultVal;
    if (typeof attrVal !== "string" || attrVal.trim() === "") return defaultVal;
    if (attrVal === "true" && defaultValType === "boolean") return true;
    if (attrVal === "false" && defaultValType === "boolean") return false;
    if (isNaN(attrVal) && defaultValType === "string") return attrVal;
    if (!isNaN(attrVal) && defaultValType === "number") return +attrVal;
    return defaultVal;
  }
  // marquee component
  $("[tr-marquee-element='component']").each(function (index) {
    let componentEl = $(this),
      panelEl = componentEl.find("[tr-marquee-element='panel']"),
      triggerHoverEl = componentEl.find("[tr-marquee-element='triggerhover']"),
      triggerClickEl = componentEl.find("[tr-marquee-element='triggerclick']");
    let speedSetting = attr(100, componentEl.attr("tr-marquee-speed")),
      verticalSetting = attr(false, componentEl.attr("tr-marquee-vertical")),
      reverseSetting = attr(false, componentEl.attr("tr-marquee-reverse")),
      scrollDirectionSetting = attr(false, componentEl.attr("tr-marquee-scrolldirection")),
      scrollScrubSetting = attr(false, componentEl.attr("tr-marquee-scrollscrub")),
      moveDistanceSetting = -100,
      timeScaleSetting = 1,
      pausedStateSetting = false;
    if (reverseSetting) moveDistanceSetting = 100;
    let marqueeTimeline = gsap.timeline({ repeat: -1, onReverseComplete: () => marqueeTimeline.progress(1) });
    if (verticalSetting) {
      speedSetting = panelEl.first().height() / speedSetting;
      marqueeTimeline.fromTo(panelEl, { yPercent: 0 }, { yPercent: moveDistanceSetting, ease: "none", duration: speedSetting });
    } else {
      speedSetting = panelEl.first().width() / speedSetting;
      marqueeTimeline.fromTo(panelEl, { xPercent: 0 }, { xPercent: moveDistanceSetting, ease: "none", duration: speedSetting });
    }
    let scrubObject = { value: 1 };
    ScrollTrigger.create({
      trigger: "body",
      start: "top top",
      end: "bottom bottom",
      onUpdate: (self) => {
        if (!pausedStateSetting) {
          if (scrollDirectionSetting && timeScaleSetting !== self.direction) {
            timeScaleSetting = self.direction;
            marqueeTimeline.timeScale(self.direction);
          }
          if (scrollScrubSetting) {
            let v = self.getVelocity() * 0.006;
            v = gsap.utils.clamp(-60, 60, v);
            let scrubTimeline = gsap.timeline({ onUpdate: () => marqueeTimeline.timeScale(scrubObject.value) });
            scrubTimeline.fromTo(scrubObject, { value: v }, { value: timeScaleSetting, duration: 0.5 });
          }
        }
      }
    });
    if (window.matchMedia("(pointer: fine)").matches) {
      triggerHoverEl.on("mouseenter", () => pauseMarquee(true));
      triggerHoverEl.on("mouseleave", () => pauseMarquee(false));
    }
    triggerClickEl.on("click", function () {
      !$(this).hasClass("is-paused") ? pauseMarquee(true) : pauseMarquee(false);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["list-collections"] && !Shopify.designMode) return;
  try {
    
  const showAnim = gsap.from('.section.is-sub-nav', { 
    yPercent: -100,
    paused: true,
    duration: 0.2
  }).progress(1);
  ScrollTrigger.create({
    trigger: ".scroll-wrapper",
    start: "top 60px",
    end: "max",
    toggleClass: {targets: ".section.is-sub-nav", className: "active"},
    onUpdate: (self) => {
      self.direction === -1 ? showAnim.play() : showAnim.reverse()    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["membership-page"] && !Shopify.designMode) return;
  try {
    
  ScrollTrigger.create({
    trigger: ".is-member-cards",
    start: "top 50%",
    end: "bottom top",
    toggleClass: {targets: ".card-gold, .card-silver, .card-bronze", className: "active"}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-basic"] && !Shopify.designMode) return;
  try {
    
function numberWithZero(num) {
  if (num < 10) {
    return "0" + num;
  } else {
    return num;
  }
}
$(".section.is-pdp-hero").each(function (index) {
  let totalSlides = numberWithZero($(this).find(".swiper-slide.is-pdp-hero").length);
$(".swiper-number-total").text(totalSlides);
const swiperPdpHero = new Swiper($(this).find(".swiper.is-pdp-hero")[0], {
  slidesPerView: 1,
  spaceBetween: 8,
  speed: 750,
  loop: 'true',
  navigation: {
    nextEl: '.swiper-btn-next',
    prevEl: '.swiper-btn-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  }
});
swiperPdpHero.on("slideChange", function (e) {
    let slideNumber = numberWithZero(e.realIndex + 1);
    $(".swiper-number-current").text(slideNumber);
  });
});
var swiperGrid = new Swiper(".swiper.is-grid", {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: 'true',
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: '.swiper-btn-next',
    prevEl: '.swiper-btn-prev',
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-business-card"] && !Shopify.designMode) return;
  try {
    
function numberWithZero(num) {
  if (num < 10) {
    return "0" + num;
  } else {
    return num;
  }
}
$(".section.is-pdp-hero").each(function (index) {
  let totalSlides = numberWithZero($(this).find(".swiper-slide.is-pdp-hero").length);
$(".swiper-number-total").text(totalSlides);
const swiperPdpHero = new Swiper($(this).find(".swiper.is-pdp-hero")[0], {
  slidesPerView: 1,
  spaceBetween: 8,
  speed: 750,
  loop: 'true',
  navigation: {
    nextEl: '.swiper-btn-next',
    prevEl: '.swiper-btn-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  }
});
swiperPdpHero.on("slideChange", function (e) {
    let slideNumber = numberWithZero(e.realIndex + 1);
    $(".swiper-number-current").text(slideNumber);
  });
});
var swiperGrid = new Swiper(".swiper.is-grid", {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: 'true',
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: '.swiper-btn-next',
    prevEl: '.swiper-btn-prev',
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-discord"] && !Shopify.designMode) return;
  try {
    
function numberWithZero(num) {
  if (num < 10) {
    return "0" + num;
  } else {
    return num;
  }
}
$(".section.is-pdp-hero").each(function (index) {
  let totalSlides = numberWithZero($(this).find(".swiper-slide.is-pdp-hero").length);
$(".swiper-number-total").text(totalSlides);
const swiperPdpHero = new Swiper($(this).find(".swiper.is-pdp-hero")[0], {
  slidesPerView: 1,
  spaceBetween: 8,
  speed: 750,
  loop: 'true',
  navigation: {
    nextEl: '.swiper-btn-next',
    prevEl: '.swiper-btn-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  }
});
swiperPdpHero.on("slideChange", function (e) {
    let slideNumber = numberWithZero(e.realIndex + 1);
    $(".swiper-number-current").text(slideNumber);
  });
});
var swiperGrid = new Swiper(".swiper.is-grid", {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: 'true',
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: '.swiper-btn-next',
    prevEl: '.swiper-btn-prev',
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
function numberWithZero(num) {
  if (num < 10) {
    return "0" + num;
  } else {
    return num;
  }
}
$(".section.is-pdp-hero").each(function (index) {
  let totalSlides = numberWithZero($(this).find(".swiper-slide.is-pdp-hero").length);
$(".swiper-number-total").text(totalSlides);
const swiperPdpHero = new Swiper($(this).find(".swiper.is-pdp-hero")[0], {
  slidesPerView: 1,
  spaceBetween: 8,
  speed: 750,
  loop: 'true',
  navigation: {
    nextEl: '.swiper-btn-next',
    prevEl: '.swiper-btn-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: 'true',
  }
});
swiperPdpHero.on("slideChange", function (e) {
    let slideNumber = numberWithZero(e.realIndex + 1);
    $(".swiper-number-current").text(slideNumber);
  });
});
var swiperGrid = new Swiper(".swiper.is-grid", {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: 'true',
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: '.swiper-btn-next',
    prevEl: '.swiper-btn-prev',
  }
});

  } catch(e) { console.error(e); }
})();
})();
